import { BackendSubscriptionType, EAPAccess, SubscriptionType } from '../../types/Subscription';
import azureFetch from '../../api/azureFetch';
import Subscription from '../../components/purchase/Subscription';

async function getEAPAccess(subscriptionClass: Subscription) {
  return new Promise<EAPAccess>((resolve, reject) => {
    try {
      subscriptionClass.fetchEAPAccess((result: EAPAccess) => {
        resolve(result);
      });
    } catch (error) {
      reject(error);
    }
  });
}

async function getAllowInviteCode (subscriptionClass: Subscription) {
  return new Promise<boolean>((resolve, reject) => {
    try {
      subscriptionClass.allowInviteCode((result: boolean) => {
        resolve(result);
      })
    } catch (error) {
      reject(error);
    }
  })
}

async function getIsAuthorizedForApp() {
  const {
    account: {
      name: organizationName,
    },
    project: {
      name: projectName,
    }
  } = VSS.getWebContext();
  try {
    return await azureFetch(
      `https://analytics.dev.azure.com/${organizationName}/${projectName}/_odata/v4.0-preview/WorkItems?$select=WorkItemId&$top=1`
    ).then((result: Response) => {
      if (result?.status === 200) {
        return true;
      }
      throw new Error('Error occurred while checking A3 Access');
    })
  } catch (error) {
    console.log(error);
    return false;
  }
}

async function getSubscription(subscriptionClass: Subscription): Promise<SubscriptionType> {
  let subscription: BackendSubscriptionType;
  
  try {
    subscription = await new Promise<BackendSubscriptionType>((resolve, reject) => {
      subscriptionClass.fetchSubscriptionInfoForCurrentUser(
        (result: BackendSubscriptionType) => {
          resolve(result);
        },
        (error: Error) => {
          reject(error);
        }
      );
    });
  } catch (error) {
    console.error('Failed to fetch subscription:', error);
    throw new Error('Backend connection failed');
  }
  const hasAllowInviteCode = await getAllowInviteCode(subscriptionClass);
  const EAPAccess = await getEAPAccess(subscriptionClass);
  const isStakeHolder = !await getIsAuthorizedForApp();

  const isTrialActive = !!(subscription?.is_trial && subscription?.trial_ends);
  const isNoSubscriptionFound = !(subscription.active && (subscription.has_user_access || subscription.has_billing_access));
  const isRestrictedBillingAccess = subscription.active && (subscription.has_billing_access && !subscription.has_user_access);

  return {
    ...subscription,
    allowInviteCode: hasAllowInviteCode,
    EAPAccess: EAPAccess,
    isStakeholder: isStakeHolder,
    isNoSubscription: isNoSubscriptionFound,
    isTrialActive: isTrialActive,
    isRestrictedBillingAccess: isRestrictedBillingAccess,
  }
}

export default getSubscription;